import { SalesOrderStatus } from '../../constants/sales-order-status.js';
/** The credit-return workflow writes Shipped only after receiveInventoryForCreditReturn, so only these mean the goods are back. */
export const RECEIVED_CREDIT_RETURN_SALES_ORDER_STATUS_IDS = new Set([
    SalesOrderStatus.SHIPPED,
    SalesOrderStatus.COMPLETE,
]);
//# sourceMappingURL=received-credit-return-sales-order-status-ids.js.map